import { Auth, AuthWithHeaders } from 'types'

/**
 * Minimal helper to extract auth headers without pulling in the heavier utils bundle.
 */
export const authFromResponse = (
  data: Omit<Auth, 'impersonatedBy'>,
  headers: { [key: string]: string },
): AuthWithHeaders => {
  return { ...data, headers: { authorization: headers.authorization } }
}

export default authFromResponse
